import React from 'react';

export const RubleIcon = () => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='48'
            height='48'
            viewBox='0 0 48 48'
            fill='none'
        >
            <rect width='48' height='48' rx='8' />
            <path
                d='M27.1987 13.7793C28.6569 13.7797 30.0563 14.3595 31.0874 15.3906C32.1184 16.422 32.6987 17.821 32.6987 19.2793C32.6987 20.7376 32.1184 22.1366 31.0874 23.168C30.0563 24.1991 28.6569 24.7789 27.1987 24.7793H22.6987V26.0312H26.8979C27.0636 26.0312 27.1986 26.1655 27.1987 26.3311V28.7314C27.1986 28.897 27.0636 29.0312 26.8979 29.0312H22.6987V35.2686C22.6986 35.4342 22.5636 35.5684 22.3979 35.5684H19.9985C19.8329 35.5684 19.6988 35.4342 19.6987 35.2686V29.0312H17.4966C17.331 29.0312 17.1959 28.897 17.1958 28.7314V26.3311C17.1959 26.1655 17.331 26.0312 17.4966 26.0312H19.6987V24.7793H17.4966C17.331 24.7793 17.1959 24.6451 17.1958 24.4795V22.0791C17.1959 21.9135 17.331 21.7793 17.4966 21.7793H19.6987V14.0791C19.6988 13.9135 19.8329 13.7793 19.9985 13.7793H27.1987ZM22.6987 21.7793H27.1987C27.8612 21.7789 28.4978 21.5154 28.9663 21.0469C29.4347 20.5781 29.6987 19.942 29.6987 19.2793C29.6987 18.6166 29.4347 17.9805 28.9663 17.5117C28.5566 17.102 28.0182 16.8483 27.4468 16.791L27.1987 16.7793H22.6987V21.7793Z'
                fill='#6257D2'
            />
            <path
                d='M24 3C12.4031 3 3 12.4031 3 24C3 35.5969 12.4031 45 24 45C35.5969 45 45 35.5969 45 24C45 12.4031 35.5969 3 24 3ZM24 41.4375C14.3719 41.4375 6.5625 33.6281 6.5625 24C6.5625 14.3719 14.3719 6.5625 24 6.5625C33.6281 6.5625 41.4375 14.3719 41.4375 24C41.4375 33.6281 33.6281 41.4375 24 41.4375Z'
                fill='#6257D2'
            />
        </svg>
    );
};
